/**
 * DEUNA · inteligencia Riverz en toda la tienda (métricas, heatmap, grabaciones)
 * y recorrido de compra evento por evento (popup de pares, referencias, checkout).
 * wireBehavior + wireRecording son copia de
 * https://riverzai.com/api/landing-lab/clone-runtime.js, SIN los shims de clones
 * (carruseles, fondo, acordeones), que sí tocarían las páginas del theme.
 * Lo carga snippets/deuna-rz-intel.liquid.
 */
(function(){
  if (window.__rzIntelLoaded) return;
  window.__rzIntelLoaded = true;
  // El runtime completo solo mide si la landing trae su propio token de Riverz
  // (un [data-rz-page] que no es el nuestro). Si no, medimos aquí: así los
  // clics dentro del popup de pares no ensucian el heatmap de la página.
  function runtimeMeasures(){
    return typeof window.__rzConv === 'function' ||
      (!!document.querySelector('[data-rz-page]:not([data-rz-intel])') &&
       !!document.querySelector('script[src*="landing-lab/clone-runtime.js"]'));
  }
  function rzGetCookie(name){
    try { var m = document.cookie.match('(^|;)\\s*' + name + '\\s*=\\s*([^;]+)'); return m ? m.pop() : ''; }
    catch(_c){ return ''; }
  }
  function rzSetCookie(name, val){
    try { document.cookie = name + '=' + val + '; Max-Age=7776000; Path=/; SameSite=Lax'; } catch(_s){}
  }
  function rzIsInternal(){
    try {
      if (/[?&]rz_internal=1/.test(location.search)) { rzSetCookie('rz_internal', '1'); return true; }
      return rzGetCookie('rz_internal') === '1';
    } catch(_i){ return false; }
  }
  function wireBehavior(){
    try {
      var pageEl = document.querySelector('[data-rz-page]');
      if (!pageEl) return;
      var inEditor = false;
      try { inEditor = !!(window.frameElement && window.frameElement.id === 'rz-canvas-frame'); } catch(_g){}
      if (inEditor) return;
      var pageId = pageEl.getAttribute('data-rz-page') || '';
      if (!pageId) return;
      if (rzIsInternal()) return; // no contar QA del dueño
      var BASE = 'https://riverzai.com/api/landing-lab/cro';

      var vid = rzGetCookie('rzab_vid') || rzGetCookie('rz_vid') || ('v' + Math.random().toString(16).slice(2) + Date.now().toString(16));
      try { rzSetCookie('rz_vid', vid); } catch(_v){}
      var sid = '', isNew = 0;
      try { sid = sessionStorage.getItem('rz_sid') || ''; } catch(_ss){}
      if (!sid) { isNew = 1; sid = 's' + Math.random().toString(16).slice(2) + Date.now().toString(16); try { sessionStorage.setItem('rz_sid', sid); } catch(_s2){} }

      var maxScroll = 0, engMs = 0, rage = 0, dead = 0, cta = 0, conv = 0, jsErr = 0, sent = false;
      var lastTick = Date.now(), t0 = Date.now();
      var clickMap = {}, clickKeys = 0;
      var grid = {}, gridKeys = 0;

      var ua = navigator.userAgent || '';
      var dev = /Mobi|Android|iPhone|iPad|iPod|Windows Phone/i.test(ua) ? 'm' : 'd';
      var br = /Edg\//i.test(ua) ? 'edge' : (/OPR\/|Opera/i.test(ua) ? 'opera' : (/Chrome\//i.test(ua) ? 'chrome' : (/Firefox\//i.test(ua) ? 'firefox' : (/Safari\//i.test(ua) ? 'safari' : 'other'))));
      function srcOf(){
        try {
          var p = new URLSearchParams(location.search);
          var us = (p.get('utm_source') || '').toLowerCase();
          if (p.get('fbclid') || /facebook|instagram|meta|\bfb\b|\big\b/.test(us)) return 'meta';
          if (p.get('ttclid') || /tiktok/.test(us)) return 'tiktok';
          if (p.get('gclid') || /google|adwords/.test(us)) return 'google';
          if (us) return us.slice(0, 16);
          var r = document.referrer || '';
          if (!r) return 'direct';
          var h = ''; try { h = new URL(r).hostname; } catch(_h){}
          if (h && location.hostname && h.indexOf(location.hostname) >= 0) return 'internal';
          if (/google|bing|duckduckgo|yahoo|ecosia/i.test(h)) return 'organic';
          return 'referral';
        } catch(_s){ return 'direct'; }
      }
      var src = srcOf();

      try { window.addEventListener('error', function(){ jsErr = 1; }, true); } catch(_er){}
      try { window.addEventListener('unhandledrejection', function(){ jsErr = 1; }, true); } catch(_ur){}

      function elLabel(el){
        try {
          var tn = (el.tagName || '').toLowerCase();
          var txt = (el.getAttribute('aria-label') || el.textContent || '').replace(/\s+/g, ' ').trim().slice(0, 28);
          if (!txt && el.id) txt = '#' + el.id;
          return (tn + '~' + (txt || '?')).slice(0, 40);
        } catch(_l){ return ''; }
      }

      function scrollPct(){
        var h = document.documentElement; var sh = (h.scrollHeight - h.clientHeight);
        if (sh <= 0) return 100;
        var top = h.scrollTop || window.pageYOffset || 0;
        var p = Math.round(top / sh * 100);
        return p < 0 ? 0 : (p > 100 ? 100 : p);
      }
      window.addEventListener('scroll', function(){ var p = scrollPct(); if (p > maxScroll) maxScroll = p; }, { passive: true });

      function rzMark(key){
        try {
          if (!key) return;
          if (clickMap[key] == null) {
            if (clickKeys >= 40) return;
            clickMap[key] = 0; clickKeys++;
          }
          clickMap[key]++;
        } catch (_m) {}
      }
      try {
        window.addEventListener('rz:cod-stage', function(e){
          var stage = e.detail;
          if (/^(open|ready|start|offer|design|invalid|submit|success|error|close)$/.test(stage || '')) rzMark('cod:' + stage);
        });
        document.addEventListener('change', function(e){
          var pack = e.target && e.target.closest && e.target.closest('[data-rz-pack]');
          if (pack) rzMark('pack:' + pack.getAttribute('data-rz-pack'));
        }, true);

        document.addEventListener('click', function(e){
          if (!e.target || !e.target.closest) return;
          if (e.target.closest('[data-rz-buybar-cta], [data-rz-buybar] button, [data-rz-buybar] a')) {
            rzMark('sticky:click');
            return;
          }
          if (e.target.closest('form[data-rz-tn-buy] button[type=submit]')) rzMark('buy:click');
        }, true);
        // Marcas propias de DEUNA (popup de pares, navegación entre referencias):
        // entran al mismo mapa de clics con nombres fijos, p. ej. pp:open, pp:model.
        window.addEventListener('rz:mark', function(e){
          var k = e && e.detail;
          if (typeof k === 'string' && /^[a-z0-9:_-]{1,30}$/.test(k)) rzMark(k);
        });
        window.addEventListener('rz:added', function(){ rzMark('buy:added'); });
        window.addEventListener('rz:checkout', function(){ rzMark('buy:checkout'); });

        if (typeof IntersectionObserver === 'function') {
          var SECS = [
            { k: 'ingredientes', re: /ingredient|activo|qué hay adentro|composici/i },
            { k: 'resenas', re: /rese|opinion|testimon|historias reales/i },
            { k: 'garantia', re: /garant|devoluci|reembols/i }
          ];
          var io2 = new IntersectionObserver(function(entries){
            entries.forEach(function(en){
              if (!en.isIntersecting) return;
              var k = en.target.getAttribute('data-rz-secmark');
              if (k) { rzMark('sec:' + k); io2.unobserve(en.target); }
            });
          }, { threshold: 0, rootMargin: '0px 0px -10% 0px' });
          var heads = document.querySelectorAll('h2, h3');
          Array.prototype.forEach.call(heads, function(h){
            var txt = (h.textContent || '').slice(0, 90);
            for (var i = 0; i < SECS.length; i++) {
              if (SECS[i].re.test(txt) && !h.getAttribute('data-rz-secmark')) {
                h.setAttribute('data-rz-secmark', SECS[i].k);
                io2.observe(h);
                break;
              }
            }
          });
        }

        document.addEventListener('click', function(e){
          var t = e.target;
          if (!t || !t.closest) return;
          if (t.closest('[data-rz-gallery-thumbs] .swiper-slide')) rzMark('gal:thumb');
          else if (t.closest('[data-rz-gallery-main] button, .product-slider-nav button')) rzMark('gal:arrow');
        }, true);

        document.addEventListener('click', function(e){
          var d = e.target && e.target.closest && e.target.closest('details, [data-rz-kind="faq"] [role="button"], .accordion-header, [class*="faq"] button');
          if (!d) return;
          var lbl = (d.textContent || '').replace(/\s+/g, ' ').trim().slice(0, 34);
          if (lbl) rzMark('faq:' + lbl);
        }, true);
        try {
          var bar0 = document.querySelector('[data-rz-buybar]');
          if (bar0 && typeof MutationObserver === 'function') {
            var visto = false;
            var mo = new MutationObserver(function(){
              if (visto) return;
              var cs = getComputedStyle(bar0);
              if (cs.display !== 'none' && cs.visibility !== 'hidden' && Number(cs.opacity) > 0.1) {
                visto = true; rzMark('sticky:view'); mo.disconnect();
              }
            });
            mo.observe(bar0, { attributes: true, attributeFilter: ['style', 'class'] });
          }
        } catch (_sb) {}
      } catch (_pdp) {}

      function tick(){ var now = Date.now(); var dt = now - lastTick; lastTick = now; if (document.visibilityState === 'visible' && dt < 30000) engMs += dt; }
      ['click','keydown','mousemove','scroll','touchstart'].forEach(function(ev){ try { window.addEventListener(ev, tick, { passive: true }); } catch(_e){} });
      try { document.addEventListener('visibilitychange', function(){ tick(); lastTick = Date.now(); }); } catch(_vc){}
      var engTimer = setInterval(tick, 5000);

      var recent = [];
      document.addEventListener('click', function(e){
        var now = Date.now();
        recent.push({ t: now, x: e.clientX || 0, y: e.clientY || 0 });
        recent = recent.filter(function(c){ return now - c.t < 1000; });
        var near = recent.filter(function(c){ return Math.abs(c.x - (e.clientX||0)) < 32 && Math.abs(c.y - (e.clientY||0)) < 32; });
        if (near.length >= 3) { rage++; recent = []; }
        // Clics dentro del popup de pares: flota sobre la página, así que no van
        // al heatmap ni cuentan como clic muerto; se miden con las marcas pp:*.
        try { if (e.target && e.target.closest && e.target.closest('.du-pp')) return; } catch(_pp){}
        try {
          var vw = window.innerWidth || 1, dh = document.documentElement.scrollHeight || 1;
          var col = Math.floor(((e.clientX || 0) / vw) * 40); col = col < 0 ? 0 : (col > 39 ? 39 : col);
          var row = Math.floor((((e.clientY || 0) + (window.pageYOffset || 0)) / dh) * 80); row = row < 0 ? 0 : (row > 79 ? 79 : row);
          var gk = dev + ':' + col + ':' + row;
          if (grid[gk] == null) { if (gridKeys < 400) { grid[gk] = 0; gridKeys++; } else gk = null; }
          if (gk) grid[gk]++;
        } catch(_hm){}
        var t = e.target, interactive = false, isCta = false;
        for (var i = 0; i < 6 && t && t !== document; i++){
          var tn = (t.tagName || '').toLowerCase();
          if (tn === 'a' || tn === 'button') { interactive = true; isCta = true; break; }
          if (tn === 'input' || tn === 'select' || tn === 'textarea' || tn === 'label' || (t.getAttribute && t.getAttribute('role') === 'button')) { interactive = true; break; }
          t = t.parentNode;
        }
        if (isCta) {
          cta++;
          var lbl = elLabel(t);
          if (lbl) {
            if (clickMap[lbl] == null) { if (clickKeys < 40) { clickMap[lbl] = 0; clickKeys++; } else lbl = null; }
            if (lbl) clickMap[lbl]++;
          }
        } else if (!interactive) dead++;
      }, true);

      try {
        window.__rzConv = function(){ conv = 1; };
        if (window.__rzConvQ) conv = 1;
      } catch(_cv){}

      function flush(){
        if (sent) return; sent = true;
        try { clearInterval(engTimer); } catch(_ci){}
        tick();
        var deciles = {}; var md = Math.floor(maxScroll / 10); md = md > 9 ? 9 : (md < 0 ? 0 : md);
        for (var di = 0; di <= md; di++) deciles[dev + ':' + di] = 1;
        var nsFlag = 0;
        try { var _h = document.documentElement; if ((_h.scrollHeight - _h.clientHeight) <= 0) nsFlag = 1; } catch(_ns){}
        var payload;
        try {
          payload = JSON.stringify({
            page: pageId, url: location.href, vid: vid, sid: sid, isNew: isNew,
            scroll: maxScroll, ns: nsFlag, eng: Math.round(engMs / 1000), time: Math.round((Date.now() - t0) / 1000),
            rage: rage, dead: dead, cta: cta, conv: conv, err: jsErr,
            dev: dev, br: br, src: src, clicks: clickMap, grid: grid, deciles: deciles
          });
        } catch(_j){ return; }
        try { if (navigator.sendBeacon) { navigator.sendBeacon(BASE + '/collect', new Blob([payload], { type: 'text/plain;charset=UTF-8' })); return; } } catch(_b){}
        try { fetch(BASE + '/collect', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: payload, keepalive: true }); } catch(_f){}
      }
      window.addEventListener('pagehide', flush);
      document.addEventListener('visibilitychange', function(){ if (document.visibilityState === 'hidden') flush(); });
    } catch(_w){ /* nunca romper la página */ }
  }

  function wireRecording(){
    try {
      var pageEl = document.querySelector('[data-rz-page]');
      if (!pageEl) return;
      var inEditor = false;
      try { inEditor = !!(window.frameElement && window.frameElement.id === 'rz-canvas-frame'); } catch(_g){}
      if (inEditor) return;
      var pageId = pageEl.getAttribute('data-rz-page') || '';
      if (!pageId) return;

      if (rzIsInternal()) return; // no grabar QA del dueño
      try {
        if (navigator.globalPrivacyControl === true || window.__rzNoRecord === true) return;
        if (document.documentElement.hasAttribute('data-rz-no-rec') ||
            (document.body && document.body.hasAttribute('data-rz-no-rec')) ||
            pageEl.hasAttribute('data-rz-no-rec')) return;
      } catch(_pc){}

      var SAMPLE = 1, sampled;
      try {
        var s = sessionStorage.getItem('rz_rec');
        if (s === null) { sampled = Math.random() < SAMPLE ? '1' : '0'; sessionStorage.setItem('rz_rec', sampled); }
        else sampled = s;
      } catch(_s){ sampled = Math.random() < SAMPLE ? '1' : '0'; }
      if (sampled !== '1') return;

      var BASE = 'https://riverzai.com';
      var rid = 'r' + Math.random().toString(16).slice(2) + Date.now().toString(16);
      var vid = rzGetCookie('rzab_vid') || rzGetCookie('rz_vid') || '';
      var sid = ''; try { sid = sessionStorage.getItem('rz_sid') || ''; } catch(_ss){}
      var dev = /Mobi|Android|iPhone|iPad|iPod|Windows Phone/i.test(navigator.userAgent || '') ? 'm' : 'd';

      var buf = [], seq = 0, stopped = false, total = 0;
      var flagRage = false, flagErr = false, flagConv = false;
      var started = Date.now(), MAX_MS = 900000, MAX_EVENTS = 20000, stop = null, timer = null;

      try { window.addEventListener('error', function(){ flagErr = true; }, true); } catch(_e){}
      try { window.addEventListener('unhandledrejection', function(){ flagErr = true; }, true); } catch(_u){}
      document.addEventListener('submit', function(){ flagConv = true; }, true);
      // Salió al checkout desde el popup: la grabación queda marcada como conversión.
      window.addEventListener('rz:checkout', function(){ flagConv = true; });
      var rc = [];
      document.addEventListener('click', function(e){
        var now = Date.now(), x = e.clientX || 0, y = e.clientY || 0;
        rc.push({ t: now, x: x, y: y }); rc = rc.filter(function(c){ return now - c.t < 1000; });
        var near = rc.filter(function(c){ return Math.abs(c.x - x) < 32 && Math.abs(c.y - y) < 32; });
        if (near.length >= 3) { flagRage = true; rc = []; }
      }, true);

      var REC_URL = BASE + '/api/landing-lab/cro/rec';
      function postChunk(events, keepalive){
        if (events.length === 0) return;
        if (keepalive && events.length > 1) {
          var probe = 0; try { probe = JSON.stringify(events).length; } catch(_p){ probe = 0; }
          if (probe >= 58000) {
            var mid = Math.ceil(events.length / 2);
            postChunk(events.slice(0, mid), keepalive);
            postChunk(events.slice(mid), keepalive);
            return;
          }
        }
        var payload;
        try {
          payload = JSON.stringify({
            page: pageId, rid: rid, url: location.href, vid: vid, sid: sid, dev: dev,
            seq: seq++, rage: flagRage, err: flagErr, conv: flagConv, events: events
          });
        } catch(_j){ return; }
        if (keepalive) {
          if (payload.length < 62000 && navigator.sendBeacon) {
            try { if (navigator.sendBeacon(REC_URL, new Blob([payload], { type: 'text/plain;charset=UTF-8' }))) return; } catch(_b){}
          }
          try { fetch(REC_URL, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: payload, keepalive: true }); } catch(_f){}
          return;
        }
        try { fetch(REC_URL, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: payload }); } catch(_f2){}
      }
      function flush(keepalive){
        var chunk = buf; buf = [];
        postChunk(chunk, keepalive);
      }
      function halt(keepalive){
        if (stopped) return; stopped = true;
        try { if (timer) clearInterval(timer); } catch(_c){}
        try { if (stop) stop(); } catch(_st){}
        flush(keepalive);
      }

      function rrwebReady(){ return window.rrweb && typeof window.rrweb.record === 'function'; }
      function begin(){
        if (!rrwebReady()) return;
        try {
          stop = window.rrweb.record({
            emit: function(ev){
              if (stopped) return;
              buf.push(ev); total++;
              if (total >= MAX_EVENTS || (Date.now() - started) > MAX_MS) halt(false);
            },
            maskAllInputs: true, recordCanvas: false, collectFonts: false,
            sampling: { mousemove: 50, scroll: 150, input: 'last' }
          });
        } catch(_r){ return; }
        setTimeout(function(){ if (!stopped) flush(false); }, 1500);
        timer = setInterval(function(){ if (!stopped) flush(false); }, 6000);
        window.addEventListener('pagehide', function(){ halt(true); });
        document.addEventListener('visibilitychange', function(){ if (document.visibilityState === 'hidden') flush(true); });
      }

      if (rrwebReady()) { begin(); return; }
      var sc = document.createElement('script');
      sc.src = BASE + '/rrweb-record.min.js'; sc.async = true;
      sc.onload = begin; sc.onerror = function(){};
      (document.head || document.documentElement).appendChild(sc);
    } catch(_w){ /* nunca romper la página */ }
  }

  function start(){
    if (window.__rzIntelStarted || runtimeMeasures()) return;
    // El marcador llega sin data-rz-page para que el runtime (que corre en el
    // load) no lo tome; recién aquí se activa y medimos nosotros.
    var tag = document.querySelector('[data-rz-intel]');
    if (!tag) return;
    if (!tag.hasAttribute('data-rz-page')) tag.setAttribute('data-rz-page', tag.getAttribute('data-rz-intel-page') || '');
    window.__rzIntelStarted = true;
    wireBehavior();
    wireRecording();
  }
  // Después del load del runtime (si la página lo trae), para no medir dos veces.
  function later(){ setTimeout(start, 600); }
  if (document.readyState === 'complete') later();
  else window.addEventListener('load', later, { once: true });

  // ── Recorrido de compra, evento por evento (tabla deuna_funnel_events) ──
  // Métricas y heatmap de Riverz son agregados por página. Esto guarda la
  // secuencia de cada visitante: qué referencias mira, qué hace en el popup de
  // pares, si llega al checkout y si vuelve. El checkout lo reporta el pixel de
  // Shopify con el mismo visitante (cookie rz_vid). Nunca se guardan datos
  // personales: solo nombres de pasos, referencias, colores y tallas.
  (function(){
    if (window.__rzFunnelOn) return;
    window.__rzFunnelOn = true;
    var KEY = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InpucmFienB3Z29pZXBjanlsamRrIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NjE0MjEwNTksImV4cCI6MjA3Njk5NzA1OX0.YhLraP1kaSTo0JdXjOLUBLCsvZXc-xFI-u4ITw0Tj5U';
    var URL_ = 'https://znrabzpwgoiepcjyljdk.supabase.co/rest/v1/rpc/rz_funnel_track?apikey=' + KEY;
    var internal = rzIsInternal();
    var dev = /Mobi|Android|iPhone|iPad|iPod|Windows Phone/i.test(navigator.userAgent || '') ? 'm' : 'd';
    var HANDLE = window.__rzHandle || null;
    var q = [], ready = false;
    function ids(){
      var vid = rzGetCookie('rzab_vid') || rzGetCookie('rz_vid');
      if (!vid) { vid = 'v' + Math.random().toString(16).slice(2) + Date.now().toString(16); rzSetCookie('rz_vid', vid); }
      var sid = ''; try { sid = sessionStorage.getItem('rz_sid') || ''; } catch(_s){}
      return { vid: vid, sid: sid };
    }
    var last = { k: '', t: 0 };
    function track(n, p, h){
      if (internal || !n) return;
      // Un toque sobre la etiqueta dispara también el clic del radio: se cuenta una vez.
      var k = n + JSON.stringify(p || {}), now = Date.now();
      if (k === last.k && now - last.t < 400) return;
      last = { k: k, t: now };
      q.push({ n: String(n), p: p || {}, h: h || HANDLE, u: location.pathname, t: Date.now() });
      if (ready && q.length >= 20) flush(false);
    }
    function flush(beacon){
      if (!q.length) return;
      var id = ids();
      var body;
      try { body = JSON.stringify({ vid: id.vid, sid: id.sid, dev: dev, src: 'store', e: q.splice(0, 60) }); } catch(_j){ q = []; return; }
      if (beacon && navigator.sendBeacon) {
        try { if (navigator.sendBeacon(URL_, new Blob([body], { type: 'text/plain;charset=UTF-8' }))) return; } catch(_b){}
      }
      try { fetch(URL_, { method: 'POST', headers: { 'Content-Type': 'text/plain' }, body: body, keepalive: true }).catch(function(){}); } catch(_f){}
    }
    // Lo que el popup y la página encolaron antes de que cargara este archivo.
    var pre = window.__rzQ || [];
    window.rzTrack = track;
    pre.forEach(function(a){ q.push({ n: a[0], p: a[1] || {}, h: a[2] || HANDLE, u: a[3] || location.pathname, t: a[4] || Date.now() }); });
    window.__rzQ = [];
    // Primer envío después del load: para entonces Riverz ya creó rz_vid y rz_sid
    // (si los creáramos antes, Riverz no contaría la sesión como nueva).
    function goReady(){ setTimeout(function(){ ready = true; flush(false); setInterval(function(){ flush(false); }, 5000); }, 1500); }
    if (document.readyState === 'complete') goReady(); else window.addEventListener('load', goReady, { once: true });
    window.addEventListener('pagehide', function(){ track('page_exit', exitProps()); flush(true); });
    document.addEventListener('visibilitychange', function(){ if (document.visibilityState === 'hidden') flush(true); });

    // Vista de página: de dónde viene y si vuelve del checkout.
    var t0 = Date.now(), maxPct = 0, marks = {};
    function pathOf(u){ try { return new URL(u).pathname; } catch(_u){ return ''; } }
    var ref = document.referrer || '', refHost = '';
    try { refHost = ref ? new URL(ref).hostname : ''; } catch(_r){}
    var own = refHost && refHost.indexOf(location.hostname.replace(/^www\./, '')) > -1;
    var fromCheckout = own && /\/checkouts?\b/.test(pathOf(ref));
    var ppBack = false; try { ppBack = sessionStorage.getItem('du_pp_ret') === '1'; } catch(_p){}
    var sp = {}; try { sp = Object.fromEntries(new URLSearchParams(location.search)); } catch(_q){}
    track('page_view', {
      type: window.__rzPageType || '', from: own ? pathOf(ref) : (refHost || 'direct'),
      utm_source: sp.utm_source || '', utm_campaign: sp.utm_campaign || '', utm_content: sp.utm_content || '',
      fbclid: sp.fbclid ? 1 : 0
    });
    if (fromCheckout || ppBack) track('checkout_return', { via: fromCheckout ? 'referrer' : 'popup_flag' });
    window.addEventListener('pageshow', function(e){ if (e.persisted) track('page_back', { from_checkout: (function(){ try { return sessionStorage.getItem('du_pp_ret') === '1'; } catch(_x){ return false; } })() }); });

    // Hasta dónde baja (25/50/75/100) y cuánto se queda.
    function pct(){ var h = document.documentElement, sh = h.scrollHeight - h.clientHeight; return sh <= 0 ? 100 : Math.round((h.scrollTop || window.pageYOffset || 0) / sh * 100); }
    window.addEventListener('scroll', function(){
      var p = pct(); if (p > maxPct) maxPct = p;
      [25, 50, 75, 100].forEach(function(m){ if (maxPct >= m && !marks[m]) { marks[m] = 1; track('scroll', { pct: m }); } });
    }, { passive: true });
    function exitProps(){ return { secs: Math.round((Date.now() - t0) / 1000), max_scroll: maxPct }; }

    // Clics con intención de compra o de comparar referencias.
    function txt(el){ return ((el && (el.getAttribute('aria-label') || el.textContent)) || '').replace(/\s+/g, ' ').trim().slice(0, 40); }
    function handleOf(href){ var m = String(href || '').match(/\/products\/([^/?#]+)/); return m ? decodeURIComponent(m[1]) : null; }
    document.addEventListener('click', function(e){
      var t = e.target; if (!t || !t.closest || t.closest('.du-pp')) return;
      var a = t.closest('a[href]');
      if (a) {
        var to = handleOf(a.getAttribute('href'));
        var zone = a.closest('.du-more') ? 'mas_referencias' : a.closest('.du-ref') ? 'catalogo' : a.closest('.du-topbar,header') ? 'header' : 'pagina';
        if (to && to !== HANDLE) { track('nav_product', { to: to, zone: zone }); try { window.dispatchEvent(new CustomEvent('rz:mark', { detail: 'nav:otra_ref' })); } catch(_m){} }
        else if (!to) track('nav_link', { to: pathOf(a.href) || a.getAttribute('href'), zone: zone, label: txt(a) });
      }
      var opt = t.closest('.rz-bundle-option');
      if (opt) { var r = opt.querySelector('input[name="rz_bundle_offer"]'); track('offer_select', { pack: r && /(^|-)2$/.test(String(r.value)) ? 2 : 1 }); }
      var c = t.closest('.rz-opt-group[data-rz-opt-name="Color"] .rz-opt-btn');
      if (c) track('page_color', { color: c.getAttribute('data-rz-opt-value') });
      var s = t.closest('.rz-opt-group[data-rz-opt-name="Talla"] .rz-opt-btn');
      if (s) track('page_size', { size: s.getAttribute('data-rz-opt-value') });
      if (t.closest('[data-rz-buybar-cta]')) track('sticky_click', {});
      else if (t.closest('[data-rz-buy], .riverz-buy-btn')) track('buy_click', { label: txt(t.closest('[data-rz-buy], .riverz-buy-btn')) });
      var d = t.closest('details > summary');
      if (d) track('faq_open', { q: txt(d) });
      var th = t.closest('.rzp-grid, [data-rz-gallery-main], [data-rz-gallery-thumbs]');
      if (th && !marks.gal) { marks.gal = 1; track('gallery_touch', {}); }
    }, true);
  })();
})();
